exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_slides_3ATuhABENEpproMC3rG2KD {\n  position: relative;\n  width: 100%;\n  height: auto;\n  float: left;\n}\n\n.IA_filters_3jkMr_6_V_TQE4rjXv0Efw {\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.IA_paginationButtonContainer_3YXnfrbcnleBKv-z-CWCCv {\n  width: 100%;\n  height: 30px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.IA_paginationPageCount_2pvNTojwsiebXsR5sDzGEq {\n  text-align: center;\n}", ""]);

// Exports
exports.locals = {
	"IA_slides": "IA_slides_3ATuhABENEpproMC3rG2KD",
	"IA_filters": "IA_filters_3jkMr_6_V_TQE4rjXv0Efw",
	"IA_paginationButtonContainer": "IA_paginationButtonContainer_3YXnfrbcnleBKv-z-CWCCv",
	"IA_paginationPageCount": "IA_paginationPageCount_2pvNTojwsiebXsR5sDzGEq"
};